export const spinSettings = {
  debug: false,
  minSpinTime: 1,
  minTurboTime: 0.5,
  delayStart: 0.01,
  delayStop: 0.01,
  spin: [
    {
      name: 'start',
      ease: 'quad.in',
      duration: 0.3,
      delay: 0.01,
      distance: -1,
      type: 'time',
    },
    {
      name: 'spin',
      stopOffset: 1, //bounce
      speed: 21,
      stopPosition: 6,
      ease: 'quad.in',
      type: 'speed',
      updateWinReel: true,
    },
    {
      name: 'stop',
      ease: 'back.out(9)',
      distance: 3,
      duration: 0.2,
      type: 'stop',
    },
    {
      name: 'snap',
      ease: 'linear',
      distance: -1,
      duration: 0.2,
      type: 'end',
    },

  ],
  turbo: [
    {
      name: 'start',
      ease: 'quad.in',
      duration: 0.1,
      delay: 0.01,
      distance: 1,
      type: 'time',
    },
    {
      name: 'spin',
      stopOffset: 1, //bounce
      speed: 60,
      stopPosition: 7,
      ease: 'quad.in',
      type: 'speed',
      updateWinReel: true,
    },
    {
      name: 'stop',
      ease: 'back.out',
      distance: 2,
      duration: 0.1,
      type: 'stop',
    },
    {
      name: 'snap',
      ease: 'linear',
      distance: -3,
      duration: 0.1,
      type: 'end',
    },
  ],
}

export const reelsSettings = {
  itemCount: [3, 3, 3, 3, 3],
  items: {
    width: 258,
    height: 278,
    default: 'static',
    states: {
      static: { path: 'images/main/items/static/' },
      dimm: { alpha: 0.6 },
    },
  },
  win: { spine: 'animations/spine/items/#replace#/skeleton.json' },
  expanding: { spine: 'animations/spine/expanding/skeleton.json' },
  stickyWild: 3,
}

export const poolSettings = { symbolCount: 12 }
